import { NgModule } from '@angular/core';
import { CallActionDialog, HeaderComponent,  } from '../header/header.component';
import { CardListComponent } from './card-list/card-list.component';
import { CourseCardComponent } from './course-card/course-card.component';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input'
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatButtonModule } from '@angular/material/button';
import { MatTabsModule } from '@angular/material/tabs';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { MatRadioModule } from '@angular/material/radio';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSelectModule } from '@angular/material/select';
import { CommonModule, DatePipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NeetFormDialog, ScoreFormDialog, SkillsFormDialog, VideoPlayerDialog } from '../home/home.component';
import { VideoGMATDialog } from '../after12/after12.component';
import { SuccessStoriesComponent } from './success-stories/success-stories.component';
import { FlagshipComponent } from './flagship/flagship.component';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatCardModule } from '@angular/material/card';
import { CourseCouponDialog, FooterViewDialog } from '../home-new/home-new.component';
import { EverythingAboutCatComponent } from './everything-about-cat/everything-about-cat.component';
import { EverythingAboutIITComponent } from './everything-about-iit/everything-about-iit.component';
import { NgChartsModule } from 'ng2-charts';
import { TopperPercentileComponent } from './topper-percentile/topper-percentile.component';
import { MAT_AUTOCOMPLETE_SCROLL_STRATEGY, MatAutocompleteModule } from '@angular/material/autocomplete';
import { SocialAuthService } from 'angularx-social-login';
import {  GalleryDialog, StarMentorsDialog } from '../home-latest/home-latest.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { TooltipModule } from 'ng2-tooltip-directive';
import { CatJourneyComponent } from './cat-journey/cat-journey.component';
import {  StepFourDialog1 } from '../agra/agra.component';
import { SkillsEnquiryModal } from '../growth/growth.component';
import { FooterNewComponent } from './footer-new/footer-new.component' ;
import { SkillsHeaderComponent } from '../skills-header/skills-header.component';
import { SkillsReviewsComponent } from '../skills-reviews/skills-reviews.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { CatCourseCardComponent } from './cat-course-card/cat-course-card.component';
import { IitMockAttemptComponent } from './iit-mock-attempt/iit-mock-attempt.component';
import { SkillFooterComponent } from './skill-footer/skill-footer.component'
import { DashboardAssignmentsIIT } from '../iit-jee-new/iit-jee-new.component';
import { MatDividerModule } from '@angular/material/divider';
import { NewCourseCardComponent } from './new-course-card/new-course-card.component'
import { MatChipsModule } from '@angular/material/chips';
import  { NeetMockAttemptComponent } from './neet-mock-attempt/neet-mock-attempt.component'
import { PipeModule } from '../pages/pipe.module';
import { WhyIquantaBestIitComponent} from './why-iquanta-best-iit/why-iquanta-best-iit.component';
import { CourseCardIitComponent } from './course-card-iit/course-card-iit.component';
import { WhyIquantaNeetComponent } from './why-iquanta-neet/why-iquanta-neet.component';
import { CourseCardNeetComponent } from './course-card-neet/course-card-neet.component';
import { CourseComparisonNeetComponent } from './course-comparison-neet/course-comparison-neet.component';
import { IitScoreVsPercentileComponent } from './iit-score-vs-percentile/iit-score-vs-percentile.component';
import { BitsatMockAttemptComponent } from './bitsat-mock-attempt/bitsat-mock-attempt.component';
import { WhyIquantaUpscComponent } from './why-iquanta-upsc/why-iquanta-upsc.component';
import { MbaInterviewCourseComponent } from './mba-interview-course/mba-interview-course.component';
import { CourseComparisonCat26Component } from './course-comparison-cat26/course-comparison-cat26.component';
import { CourseComparisonIitComponent } from './course-comparison-iit/course-comparison-iit.component';
import { BlockScrollStrategy, Overlay } from '@angular/cdk/overlay';
import { AbcJourneyComponent } from './abc-journey/abc-journey.component';
import {VideoPlayerCourseDialog} from '../fullcoursecat/fullcoursecat.component'

export function scrollFactory(overlay: Overlay): () => BlockScrollStrategy {
  return () => overlay.scrollStrategies.block();
}
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    MatTooltipModule,
    MatMenuModule,
    MatDialogModule,
    MatSnackBarModule,
    MatButtonModule,
    SlickCarouselModule,
    MatTabsModule,
    MatRadioModule,
    MatExpansionModule,
    MatCheckboxModule,
    MatButtonToggleModule,
    MatIconModule,
    RouterModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatCardModule,
    NgChartsModule,
    MatAutocompleteModule,
    NgxSpinnerModule,
    TooltipModule,
    NgxMatSelectSearchModule,
    MatDividerModule,
    MatChipsModule,
    PipeModule
  ],

  declarations: [
    HeaderComponent,
    CourseCardComponent,
    CardListComponent,
    VideoPlayerDialog,
    VideoGMATDialog,
    FlagshipComponent,
    SuccessStoriesComponent,
    CallActionDialog,
    CourseCouponDialog,
    FooterViewDialog,
    EverythingAboutCatComponent,
    EverythingAboutIITComponent,
    TopperPercentileComponent,
    GalleryDialog,
    StarMentorsDialog,
    CatJourneyComponent,
    StepFourDialog1,
    SkillsEnquiryModal,
    FooterNewComponent,
    SkillsHeaderComponent,
    SkillsReviewsComponent,
    CatCourseCardComponent,
    IitMockAttemptComponent,
    SkillFooterComponent,
    DashboardAssignmentsIIT,
    NewCourseCardComponent,
    SkillsFormDialog,
    ScoreFormDialog,
    NeetMockAttemptComponent,
    NeetFormDialog,
    WhyIquantaBestIitComponent,
    CourseCardIitComponent,
    WhyIquantaNeetComponent,
    CourseCardNeetComponent,
    CourseComparisonNeetComponent,
    IitScoreVsPercentileComponent,
    BitsatMockAttemptComponent,
    WhyIquantaUpscComponent,
    MbaInterviewCourseComponent,
    CourseComparisonCat26Component,
    CourseComparisonIitComponent,
    AbcJourneyComponent,
    VideoPlayerCourseDialog
  ],

  exports: [
    HeaderComponent,
    CourseCardComponent,
    CardListComponent,
    VideoPlayerDialog,
    VideoGMATDialog,
    SuccessStoriesComponent,
    FlagshipComponent,
    CallActionDialog,
    CourseCouponDialog,
    FooterViewDialog,
    EverythingAboutCatComponent,
    EverythingAboutIITComponent,
    TopperPercentileComponent,
    GalleryDialog,
    StarMentorsDialog,
    CatJourneyComponent,
    StepFourDialog1,
    SkillsEnquiryModal,
    FooterNewComponent,
    SkillsHeaderComponent,
    SkillsReviewsComponent,
    CatCourseCardComponent,
    IitMockAttemptComponent,
    SkillFooterComponent,
    DashboardAssignmentsIIT,
    NewCourseCardComponent,
    SkillsFormDialog,
    ScoreFormDialog,
    NeetMockAttemptComponent,
    NeetFormDialog,
    PipeModule,
    WhyIquantaBestIitComponent,
    CourseCardIitComponent,
    WhyIquantaNeetComponent,
    CourseCardNeetComponent,
    CourseComparisonNeetComponent,
    IitScoreVsPercentileComponent,
    BitsatMockAttemptComponent,
    WhyIquantaUpscComponent,
    MbaInterviewCourseComponent,
    CourseComparisonCat26Component,
    CourseComparisonIitComponent,
    AbcJourneyComponent,VideoPlayerCourseDialog
  ],
  providers: [
    DatePipe,
    SocialAuthService,
    {
      provide: MAT_AUTOCOMPLETE_SCROLL_STRATEGY,
      useFactory: scrollFactory,
      deps: [Overlay],
    },
  ]

})
export class ComponentsModule { }
